// 콜미텔미 Footer

import {
  Box,
  Button,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

export default function Footer() {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const navigationLinks = [
    '공지사항',
    '강사 지원하기',
    '개인정보보호정책',
    '저작권 안내',
    '자주 묻는 질문',
    '채용',
    '서비스 이용약관',
  ];

  const socialLinks = [
    {
      name: '네이버 블로그',
      logo: '/static/logo/naver-blog.png',
    },
    {
      name: '네이버 카페',
      logo: '/static/logo/naver-cafe.png',
    },
    {
      name: 'Youtube',
      logo: '/static/logo/youtube.png',
    },
    {
      name: '인스타그램',
      logo: '/static/logo/instagram.png',
    },
  ];

  return (
    <Box
      sx={{
        width: '100%',
        background: '#ffffff',
        color: '#666',
        mt: 8,
        py: 4,
        px: { xs: 2, md: 8 },
        fontSize: '14px',
        position: 'relative',
        borderTop: `1.5px solid ${theme.palette.primary.grey10}`,
      }}
    >
      {/* Navigation Links */}
      <Box
        sx={{
          mb: isTablet ? 2 : 3,
          textAlign: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: isTablet ? 'flex-start' : 'center',
          gap: { xs: 1, sm: 2 },
        }}
      >
        {navigationLinks.map((link, index) => (
          <Link
            key={index}
            href="#"
            sx={{
              color: theme.palette.primary.dark,
              fontSize: { xs: '13px', sm: '14px' },
              fontWeight: 400,
              textDecoration: 'none',
              px: { xs: 1, sm: 2 },
              py: 0,
              whiteSpace: 'nowrap',
            }}
          >
            {link}
          </Link>
        ))}
      </Box>

      {/* Social Media Links */}
      <Box
        sx={{
          mb: isTablet ? 2 : 3,
          textAlign: 'center',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: isTablet ? 'flex-start' : 'center',
          gap: { xs: 1, sm: 2 },
        }}
      >
        {socialLinks.map((social, index) => (
          <Link
            key={index}
            href="#"
            sx={{
              color: theme.palette.primary.dark,
              fontSize: { xs: '13px', sm: '14px' },
              fontWeight: 400,
              px: { xs: 1, sm: 2 },
              py: { xs: 0.5, sm: 0 },
              textDecoration: 'none',
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              '&:hover': {
                opacity: 0.8,
              },
            }}
          >
            <Box
              component="img"
              src={social.logo}
              alt={social.name}
              sx={{
                width: { xs: 16, sm: 18 },
                height: { xs: 16, sm: 18 },
                objectFit: 'contain',
              }}
            />
            {social.name}
          </Link>
        ))}
      </Box>

      {/* Contact Button */}
      <Box sx={{ mb: 3, textAlign: 'center' }}>
        <Button
          sx={{
            width: '100%',
            maxWidth: '750px',
            backgroundColor: theme.palette.primary.mainBlue,
            color: 'white',
            px: 4,
            py: 1,
            borderRadius: '10px',
            fontSize: '14px',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: theme.palette.primary.mainBlue,
            },
          }}
        >
          문의하기
        </Button>
      </Box>

      {/* Company Information */}
      <Box sx={{ textAlign: 'center', fontSize: '13px', color: '#999' }}>
        <Typography
          sx={{
            mb: 2,
            fontSize: { xs: '13px', sm: '14px' },
            color: '#999',
            fontWeight: 400,
          }}
        >
          <span
            style={{ color: theme.palette.primary.dark, marginRight: '6px' }}
          >
            평일 10:00 - 18:00
          </span>{' '}
          {isTablet && <br />}
          점심시간 12 - 13시 | 주말 및 공휴일 휴무
        </Typography>

        <Box sx={{ display: 'inline-block' }}>
          <Typography
            sx={{
              textAlign: 'left',
              fontSize: { xs: '13px', sm: '14px' },
              color: '#999',
              fontWeight: 400,
            }}
          >
            슈가컴퍼니(주) 대표
            <br />
            사무실 서울시 서초구 사암당로 143, 크로스 143타워 2층
            <br />
            서울시 강남구 역삼로 134, MS빌딩 2층 | 사업자등록번호 323423333
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
